export default __webpack_public_path__ + "ad95445d16313cc2402fcb971b1e2fcc.svg";